import instance from "@/plugins/axios";
import { reactive } from "vue";

export const appCustom = reactive({
  logo: {},
  banners: [],
  loading: false,
  error: null
});

export const fetchAppProps = async () => {
  return new Promise((resolve, reject) => {
    appCustom.loading = true;
    instance
      .get("/group/@me/customization")
      .then((res) => {
        const data = res.data;
        appCustom.banners = data.banners;
        appCustom.logo = data.logo;
        appCustom.loading = false;
        resolve(res.data);
      })
      .catch((err) => {
        appCustom.error = err;
        appCustom.loading = false;
        reject(err);
      });
  });
}